<div
  class="content w-full lg:h-(--height-full) h-[calc(var(--height-full)-80px)] bg-(--comp-app-bg) flex flex-col"
>
  <div
    class="py-4 justify-center flex-col items-start px-4 lg:flex-row lg:justify-between gap-4 lg:h-21 lg:flex hidden"
  >
    <app-tab-menu-simple
      class="w-[-webkit-fill-available]"
      [tabs]="taps"
      [indexSelected]="statusSelected"
      (changeSelected)="onStatusSelectedChange($event)"
      [titule]="'Menu Solicitudes:'"
    ></app-tab-menu-simple>
  </div>

  @if (statusSelected == 0 && locationDetail && locationDetailArray.length) {
    <app-products
      [locationDetailArray]="locationDetailArray"
      [productInCar]="productInCar"
      [locationDetail]="locationDetail"
    ></app-products>
  }
  @if (statusSelected == 1 && locationDetail) {
    <app-cart-products
      [productInCar]="productInCar"
      [locationDetail]="locationDetail"
    ></app-cart-products>
  }
  @if (statusSelected == 2 && locationDetail) {
    <app-profile-component
      [locationDetailArray]="locationDetailArray"
      [productInCar]="productInCar"
      [locationDetail]="locationDetail"
    ></app-profile-component>
  }
</div>
